import { COLOR } from '@/shared/constant/color'
import { ModalBtn } from '@/styles/common/CommonForm/buttonform'
import { ModalConfirmContent, ModalOnlyTitle } from '@/styles/common/modal'

interface ConfirmModalProps {
  message: string
  onCancel: () => void
  onConfirm: () => void
  cancelText?: string
  confirmText?: string
}

const ConfirmModal = ({
  message,
  onCancel,
  onConfirm,
  cancelText = '취소',
  confirmText = '확인',
}: ConfirmModalProps): JSX.Element => {
  return (
    <ModalConfirmContent>
      <ModalOnlyTitle>{message}</ModalOnlyTitle>
      <section>
        <ModalBtn bgColor={COLOR.blueGray3} onClick={onCancel}>
          <span>{cancelText}</span>
        </ModalBtn>
        <ModalBtn bgColor={COLOR.point1} onClick={onConfirm}>
          <span>{confirmText}</span>
        </ModalBtn>
      </section>
    </ModalConfirmContent>
  )
}

export default ConfirmModal
